import { useQuery } from 'react-query';
import { CommissionInvoice } from '../../../types/models/commission/commission.types';
import { queryAllCommissionsInvoices } from './useCommissionsInvoices.query';

export const ALL_COMMISSIONS_INVOICES_QUERY_KEY = 'ALL_COMMISSIONS_INVOICES';

export const useCommissionsInvoices = () => {
  return useQuery<CommissionInvoice[], Error>(ALL_COMMISSIONS_INVOICES_QUERY_KEY, () =>
    queryAllCommissionsInvoices()
  );
};
